import component from './index';

import less from '!raw-loader!./index.less';
import templateStr from '!raw-loader!./index';

export default {
  component,
  templateStr,
  less,
  dataSource: {
    wrapper: {
      className: 'home-page-wrapper content8-wrapper',
    },
    page: {
      className: 'home-page content8',
    },
    OverPack: {
      playScale: 0.3,
    },
    titleWrapper: {
      className: 'title-wrapper',
      children: [
        {
          name: 'image',
          children: 'https://gw.alipayobjects.com/zos/rmsportal/PiqyziYmvbgAudYfhuBr.svg',
          className: 'title-image',
        },
        {
          name: 'title',
          children: '特邀嘉宾',
          className: 'title-h1',
        },
      ],
    },
    block: {
      className: 'content-wrapper',
      children: [
        {
          name: 'block0',
          md: 6,
          xs: 24,
          className: 'content8-block-wrapper',
          children: {
            className: 'content8-block',
            img: {
              className: 'content8-img',
              children: 'https://gw.alipayobjects.com/zos/rmsportal/JahzbVrdHdJlkJjkNsBJ.png',
            },
            title: {
              className: 'content8-title',
              children: 'Jack',
            },
            content: {
              className: 'content8-content',
              children: '公司+职位 信息暂缺',
            },
          },
        },
        {
          name: 'block1',
          md: 6,
          xs: 24,
          className: 'content8-block-wrapper',
          children: {
            className: 'content8-block',
            img: {
              className: 'content8-img',
              children: 'https://gw.alipayobjects.com/zos/rmsportal/JahzbVrdHdJlkJjkNsBJ.png',
            },
            title: {
              className: 'content8-title',
              children: 'Jack',
            },
            content: {
              className: 'content8-content',
              children: '公司+职位 信息暂缺',
            },
          },
        },
        {
          name: 'block2',
          md: 6,
          xs: 24,
          className: 'content8-block-wrapper',
          children: {
            className: 'content8-block',
            img: {
              className: 'content8-img',
              children: 'https://gw.alipayobjects.com/zos/rmsportal/JahzbVrdHdJlkJjkNsBJ.png',
            },
            title: {
              className: 'content8-title',
              children: 'Jack',
            },
            content: {
              className: 'content8-content',
              children: '公司+职位 信息暂缺',
            },
          },
        },
        {
          name: 'block3',
          md: 6,
          xs: 24,
          className: 'content8-block-wrapper',
          children: {
            className: 'content8-block',
            img: {
              className: 'content8-img',
              children: 'https://gw.alipayobjects.com/zos/rmsportal/JahzbVrdHdJlkJjkNsBJ.png',
            },
            title: {
              className: 'content8-title',
              children: 'Jack',
            },
            content: {
              className: 'content8-content',
              children: '公司+职位 信息暂缺',
            },
          },
        },
        {
          name: 'block4',
          md: 6,
          xs: 24,
          className: 'content8-block-wrapper',
          children: {
            className: 'content8-block',
            img: {
              className: 'content8-img',
              children: 'https://gw.alipayobjects.com/zos/rmsportal/JahzbVrdHdJlkJjkNsBJ.png',
            },
            title: {
              className: 'content8-title',
              children: 'Jack',
            },
            content: {
              className: 'content8-content',
              children: '公司+职位 信息暂缺',
            },
          },
        },
        {
          name: 'block5',
          md: 6,
          xs: 24,
          className: 'content8-block-wrapper',
          children: {
            className: 'content8-block',
            img: {
              className: 'content8-img',
              children: 'https://gw.alipayobjects.com/zos/rmsportal/JahzbVrdHdJlkJjkNsBJ.png',
            },
            title: {
              className: 'content8-title',
              children: 'Jack',
            },
            content: {
              className: 'content8-content',
              children: '公司+职位 信息暂缺',
            },
          },
        },
        {
          name: 'block6',
          md: 6,
          xs: 24,
          className: 'content8-block-wrapper',
          children: {
            className: 'content8-block',
            img: {
              className: 'content8-img',
              children: 'https://gw.alipayobjects.com/zos/rmsportal/JahzbVrdHdJlkJjkNsBJ.png',
            },
            title: {
              className: 'content8-title',
              children: 'Jack',
            },
            content: {
              className: 'content8-content',
              children: '公司+职位 信息暂缺',
            },
          },
        },
        {
          name: 'block7',
          md: 6,
          xs: 24,
          className: 'content8-block-wrapper',
          children: {
            className: 'content8-block',
            img: {
              className: 'content8-img',
              children: 'https://gw.alipayobjects.com/zos/rmsportal/JahzbVrdHdJlkJjkNsBJ.png',
            },
            title: {
              className: 'content8-title',
              children: 'Jack',
            },
            content: {
              className: 'content8-content',
              children: '公司+职位 信息暂缺',
            },
          },
        },
      ],
    },
  },
};
